import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-48e65ffd");

var _hoisted_1 = {
  class: "li_container"
};
var _hoisted_2 = {
  class: "li_info--wrapper"
};
var _hoisted_3 = {
  class: "invitation-wrapper"
};
var _hoisted_4 = {
  class: "li_invitedNum"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode("邀请 ");

var _hoisted_6 = /*#__PURE__*/_createTextVNode("人获得");

var _hoisted_7 = {
  class: "li_joining"
};
var _hoisted_8 = {
  class: "li_last"
};
var _hoisted_9 = {
  class: "data-wrapper"
};
var _hoisted_10 = {
  class: "li_date"
};

var _hoisted_11 = /*#__PURE__*/_createTextVNode(" 邀请好友 ");

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" 补货中 ");

var _hoisted_13 = {
  class: "dialog-info-wrapper"
};

var _hoisted_14 = /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "确定选择这个任务？", -1);

var _hoisted_15 = {
  class: "dialog-info"
};

var _hoisted_16 = /*#__PURE__*/_createTextVNode("邀请");

var _hoisted_17 = /*#__PURE__*/_createTextVNode("人获得 ");

var _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

var _hoisted_19 = /*#__PURE__*/_createTextVNode();

var _hoisted_20 = {
  class: "dialog-button-wrapper"
};

var _hoisted_21 = /*#__PURE__*/_createTextVNode("确定，开始邀请好友");

var _hoisted_22 = /*#__PURE__*/_createTextVNode("再换一个 ");

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_image = _resolveComponent("van-image");

  var _component_van_button = _resolveComponent("van-button");

  var _component_van_overlay = _resolveComponent("van-overlay");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["li_wrapper", {
      'sell-out': $props.item.stock === '0'
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "img--wrapper",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.onClickList($props.item);
    })
  }, [_createVNode(_component_van_image, {
    "lazy-load": "",
    width: "88",
    height: "88",
    fit: "cover",
    src: 'https://cdn-fs.touchev.com' + $props.item.coverImgUrl + '!w240',
    alt: ""
  }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, [_hoisted_5, _createElementVNode("span", null, _toDisplayString($props.item.inviteNum), 1), _hoisted_6]), _createElementVNode("p", _hoisted_7, [_createElementVNode("span", null, _toDisplayString($props.item.applicationNum) + "个人正在任务中", 1)])]), _createElementVNode("p", {
    class: "li_title",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.onClickList($props.item);
    })
  }, _toDisplayString($props.item.title), 1), _createElementVNode("p", _hoisted_8, " 库存 " + _toDisplayString($props.item.goodsNum) + " 个 价值：" + _toDisplayString($props.item.goodsPrice) + "元 ", 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString($props.item.startTime.split(" ")[0]) + " ~ " + _toDisplayString($props.item.endTime.split(" ")[0]), 1), $props.item.status === '1' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.isSelected ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$props.index === _ctx.isSelected - 0 ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    round: "",
    size: "small",
    type: "primary",
    color: "#FE5340",
    onClick: $options.shareFriends
  }, {
    default: _withCtx(function () {
      return [_hoisted_11];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$props.item.goodsNum === '0' ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    round: "",
    size: "small",
    type: "primary",
    color: "#B6B6B6"
  }, {
    default: _withCtx(function () {
      return [_hoisted_12];
    }),
    _: 1
  })) : $props.item.goodsNum !== '0' ? (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    round: "",
    size: "small",
    type: "primary",
    color: "#FE5340",
    onClick: $options.showDialog
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString($options.statusText), 1)];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)], 64))], 64)) : _createCommentVNode("", true)])])]), _createVNode(_component_van_overlay, {
    show: $data.dialogShow,
    "z-index": "3"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("p", _hoisted_15, [_hoisted_16, _createElementVNode("span", null, _toDisplayString($props.item.inviteNum), 1), _hoisted_17, _hoisted_18, _hoisted_19, _createElementVNode("span", null, _toDisplayString($props.item.title), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("ul", null, [_createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = function () {
          return $options.doJoinActivity && $options.doJoinActivity.apply($options, arguments);
        })
      }, [_createVNode(_component_van_button, {
        block: "",
        round: "",
        size: "normal",
        type: "primary",
        color: "#FC9224"
      }, {
        default: _withCtx(function () {
          return [_hoisted_21];
        }),
        _: 1
      })]), _createElementVNode("li", {
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return $data.dialogShow = false;
        })
      }, [_createVNode(_component_van_button, {
        block: "",
        plain: "",
        round: "",
        size: "normal",
        type: "primary",
        color: "#FC9224"
      }, {
        default: _withCtx(function () {
          return [_hoisted_22];
        }),
        _: 1
      })])])])])];
    }),
    _: 1
  }, 8, ["show"])], 2);
}